import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import RightOutlinedSvg from "@ant-design/icons-svg/es/asn/RightOutlined";
import AntdIcon from "../components/AntdIcon";
var RightOutlined = function RightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RightOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  RightOutlined.displayName = 'RightOutlined';
}
export default /*#__PURE__*/React.forwardRef(RightOutlined);